export default "__VITE_ASSET__cXyP$yZq__"